import React from 'react'
import {Field, reduxForm} from 'redux-form'
import FlatButton from 'material-ui/FlatButton';

import DoneIcon from 'material-ui/svg-icons/action/done';
import PersonIcon from 'material-ui/svg-icons/social/person';
import ForwardIcon from 'material-ui/svg-icons/content/forward';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import LockIcon from 'material-ui/svg-icons/action/lock-outline';
import ReplyIcon from 'material-ui/svg-icons/content/reply';

import Dialog from 'material-ui/Dialog';
import {Link} from 'react-router-dom';

import moment from 'moment'

import * as colors from 'material-ui/styles/colors';
import FormLabel from '../components/FormLabel'
import FormAutoComplete2 from '../components/FormAutoComplete2'
import FormText from '../components/FormText'
import FormHidden from '../components/FormHidden'
import FormSelect from '../components/FormSelect'
import FormCheckBox from '../components/FormCheckBox'

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import * as commons from '../commons';
import styles from '../styles'

import {
    isMobile
} from "react-device-detect";

const dataSourceConfig = {
  text: 'textKey',
  value: 'valueKey',
};

class RoumuForm extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      roumuKind: '',
      workKind: '',
      open: false,
      applicaRefOpen: false
    }

  }

  handleNewRequest = (value, index) => {

    const {
      onKenmeiCodeChange,
      kenmeiCodes,
      change
    } = this.props

    if (index === -1) {
      return
    }

    const kenmei = kenmeiCodes[index] || {}

    change('costId', '')
    change('yosanId', '')
    onKenmeiCodeChange(
      {
        kenmeiName: kenmei.name,
        branchOfficeName: kenmei.branchOfficeName,
        departmentName: kenmei.departmentName,
        customerName: kenmei.customerName,
        constructionName: kenmei.constructionName,
        address: kenmei.address,
      }
    )

  }

  handleUpdateInput = (value) => {

    const {
      onKenmeiCodeChange,
      kenmeiCodes,
      change
    } = this.props

    const kenmei = kenmeiCodes.find(x => {
      return x.code == value
    })

    change('costId', '')
    change('yosanId', '')
    if (kenmei) {
      onKenmeiCodeChange(
        {
          kenmeiName: kenmei.name,
          branchOfficeName: kenmei.branchOfficeName,
          departmentName: kenmei.departmentName,
          customerName: kenmei.customerName,
          constructionName: kenmei.constructionName,
          address: kenmei.address,
        }
      )
    } else {
      onKenmeiCodeChange(
        {
          kenmeiName: "ー",
          branchOfficeName: "ー",
          departmentName: "ー",
          customerName: "ー",
          constructionName: "ー",
          address: "ー",
        }
      )
    }

  }
  
  getEventTitle(kind) {
    switch(kind) {
      case 1 :
        return "通常出勤"
      case 2 :
        return "祝休日"
      case 3 :
        return "振替休暇"
      case 4 :
        return "代休 (全休)"
      case 5 :
        return "代休（半休)"
      case 6 :
        return "有給（全休）"
      case 7 :
        return "有給（半休）"
      case 8 :
        return "特別休暇（有給）"
      case 9 :
        return "特別休暇（無休）"
      case 10 :
        return "休出給与振替 (8)"
      case 11 :
        return "休出給与振替（4)"
      default:
    }
  }


  hankaku(value) {
    return value.replace(/[０-９：]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 65248);
    });
    // return c.replace('：', ':')
  }

   lower(value){
      return value && value.toLowerCase()
   }

    render() {

    const {
      auth,
      sameGroup,
      myData,
      initialValues,

      editUserId,
      editUserName,

      kenmeiCodes,
      kenmeiCodeDataSource,
      works,
      yosanCosts,
      workHoliday,

      selectedKenmeiCode,
      selectedKind,
      selectedYosanId,
      onKenmeiCodeChange,
      currentKenmei,

      onYosanCostClick,
      onWorkHolidayClick,

      onClickOK,
      onClickNext,
      onClickClose,
      onClickDelete,
      onClickApproval,
      onClickReply,
      //ReduxFormProps
      // error, handleSubmit, pristine, reset, submitting, submitFailed, submitSucceeded
      change,
      error, handleSubmit, pristine, submitting,
      dirty,
      onLocalStorageSave,
      onFormReset
    } = this.props

        if (!initialValues) {
            return (<div></div>)
        }

        const autoCompleteAnchor = isMobile ?
            { vertical: 'center', horizontal: 'right',}
            :
            { vertical: 'bottom', horizontal: 'left',}

    return (

      <form onSubmit={handleSubmit(onClickOK(editUserId, yosanCosts, workHoliday))}>

        {initialValues.date}

        <Link className="button" to={`/subHoliday/${editUserId}/${editUserName}/${moment(initialValues.date, 'YYYY/MM/DD').format('YYYYMMDD')}`} >
          <FlatButton
            label="代休管理へ遷移"
            primary={true}
            style={{marginLeft: 10}}
          />
        </Link>

        { initialValues.id &&
        <FlatButton
          label="残業申請状況を表示"
          primary={true}
          onTouchTap={() => {
            this.setState(Object.assign(this.state, {applicaRefOpen: true}))
          }}
        />
        }

        {initialValues.workHolidayDate && 
          (
            <div>
              <div>
                <div style={{marginTop: 30, fontSize: 14}}>{initialValues.workHolidayDate} 休出分を「{this.getEventTitle(initialValues.kind)} 」に振替えます。</div>
              </div>
            </div>
          )
        }

        {error && <div><span style={{ color: 'rgb(244, 67, 54)' }}>{error}</span></div>}

        {!initialValues.workHolidayDate && 


(
  <div>


        <Field name="yosanId" component={FormHidden} />

        <div className="row">
          <div className="col-4">
            <Field
              name={`kind`}
              component={FormSelect}
              style={{ width: '100%' }}
              label="休暇区分"
              disabled={initialValues.workHolidayDate ? true : false}
              onChange={(event, index, value) => {
              }}
            >
              <MenuItem value={''} primaryText="" />
              <MenuItem value={6} primaryText="有給休暇（全日）" />
              <MenuItem value={7} primaryText="有給休暇（半日）" />
              <MenuItem value={8} primaryText="特別休暇（有給）" />
              <MenuItem value={9} primaryText="特別休暇（無給）" />
            </Field>
          </div>

          <div className='col-5'>

          {initialValues.workHolidayDate &&
            (<FormLabel title='休出日' name='workHolidayDate' value={initialValues.workHolidayDate}/>)
          }

          </div>


        </div>
        <div className="row">
          <div className="col-4">
            <Field
                name="kenmeiCode"
                dataSourceConfig={dataSourceConfig}
                dataSource={kenmeiCodeDataSource}
                component={FormAutoComplete2}
                floatingLabelText="件名番号"
                filter={(searchText, key) => {
                  if (searchText == '') {
                    return true
                  }
                  return key.startsWith(commons.convertHarf(searchText))
                  // return searchText !== '' && key.indexOf(searchText) !== -1
                }}
                onNewRequest={this.handleNewRequest}
                onUpdateInput={this.handleUpdateInput}
                textFieldStyle={{ width: '100%'}}
                style={{ width: '100%'}}
                anchorOrigin = {autoCompleteAnchor}
                // menuStyle = {{backgroudColor: 'red', opacity: '0.5'}}
                // menuProps={}
                // listStyle={{marginTop:'100px'}}
              />
          </div>
          <div className="col-4">

            <FormLabel title='件名名称' name='kenmeiName' value={currentKenmei.kenmeiName} />

          </div>

          <div className="col-4">

            <FormLabel title='客先' name='customerName' value={currentKenmei.customerName} />

          </div>

        </div>

        {/*<div className="row">*/}
            {/*<div className="col-4">*/}

                {/*<FormLabel title='件名名称' name='kenmeiName' value={currentKenmei.kenmeiName} />*/}

            {/*</div>*/}

            {/*<div className="col-4">*/}

                {/*<FormLabel title='客先' name='customerName' value={currentKenmei.customerName} />*/}

            {/*</div>*/}
        {/*</div>*/}

        <div className="row">

          <div className="col-4">
            <Field
              name="startTime"
              component={FormText}
              label="開始時間"
              style={{ width: '200px' }}
              // normalize={this.hankaku}
            />
          </div>

          <div className="col-2" style={{paddingTop: '15px', display: 'flex', alignItems: 'center'}}>
            <div>
              <Field label="直行" name="directWork" component={FormCheckBox}
                      style={{ ...styles.checkRemember.style, fontSize: 13, width: '100px'}}
                      labelStyle={styles.checkRemember.labelStyle}
                      iconStyle={styles.checkRemember.iconStyle}
              />
            </div>
          </div>

          <div className="col-4">
            <Field
              name="endTime"
              component={FormText}
              label="終了時間"
              style={{ width: '200px' }}
              // normalize={this.hankaku}
            />
          </div>

          
          <div className="col-2" style={{paddingTop: '15px', display: 'flex', alignItems: 'center'}}>
            <div>
              <Field label="直帰" name="directHome" component={FormCheckBox}
                      style={{ ...styles.checkRemember.style, fontSize: 13, width: '100px'}}
                      labelStyle={styles.checkRemember.labelStyle}
                      iconStyle={styles.checkRemember.iconStyle}
              />
            </div>
          </div>

        </div>

        <div className='row'>
          <div className='col-4'>

            <Field
              name={`costId`}
              component={FormSelect}
              style={{ width: '100%' }}
              label="予算労務種別"
              onClick={onYosanCostClick(selectedYosanId, selectedKenmeiCode)}
            >
              <MenuItem value={''} primaryText="" />
              {
                yosanCosts && yosanCosts.map((x, index) => {
                  return (<MenuItem key={index} value={x.costId} primaryText={x.text} />)
                })
              }
            </Field>
          </div>
          <div className='col-4'>
            
            <Field
              name={`workId`}
              component={FormSelect}
              style={{ width: '100%' }}
              label="作業種別"
            >
              <MenuItem value={''} primaryText="" />
              {
                works && works.map((x, index) => {
                  return (<MenuItem key={index} value={x.id} primaryText={x.work} />)
                })
              }
            </Field>

          </div>
        </div> 
        <div className="row">
          <div className="col-8">
            <Field
              name="comment"
              component={FormText}
              label="備考"
              style={{ width: '100%' }}
            />
          </div>
        </div>

</div>
)
}

        <div style={{ textAlign: 'right', padding: 8, margin: '24px -24px -24px -24px' }}>

          <FlatButton
            label="キャンセル"
            primary={true}
            labelStyle={{ color: colors.grey500, lineHeight: '40px' }}
            style={{ height: '40px', width: '120px', marginRight: '20px' }}
            onTouchTap={onClickClose(dirty)}
          />

          <FlatButton
            label="クリア"
            primary={true}
            labelStyle={{ color: colors.grey500, lineHeight: '40px' }}
            style={{height: '40px', width: '100px', marginRight: '20px'}}
            onClick={() => {
              onFormReset()
            }}
          />

          {
            !initialValues.id &&
            <FlatButton
              label="固定"
              labelPosition="before"
              primary={true}
              labelStyle={{color: colors.white, lineHeight: '40px'}}
              style={{height: '40px', width: '100px', marginRight: '20px'}}
              backgroundColor={colors.grey600}
              hoverColor={colors.grey800}
              icon={<LockIcon color={colors.white}/>}
              onClick={handleSubmit(onLocalStorageSave)}
            />

          }

          { initialValues.id && auth.user.permission == 2 &&
            <FlatButton
              label="削除"
              labelPosition="before"
              primary={true}
              labelStyle={{color: colors.white, lineHeight: '40px'}}
              style={{height: '40px', width: '100px', marginRight: '20px'}}
              backgroundColor={colors.grey600}
              hoverColor={colors.grey800}
              icon={<DeleteIcon color={colors.white}/>}
              onTouchTap={handleSubmit(onClickDelete(editUserId, yosanCosts))}
            />
          }

            { initialValues.id && auth.user.permission == 3 && sameGroup &&
            <FlatButton
                label="削除"
                labelPosition="before"
                primary={true}
                labelStyle={{color: colors.white, lineHeight: '40px'}}
                style={{height: '40px', width: '100px', marginRight: '20px'}}
                backgroundColor={colors.grey600}
                hoverColor={colors.grey800}
                icon={<DeleteIcon color={colors.white}/>}
                onTouchTap={handleSubmit(onClickDelete(editUserId, yosanCosts))}
            />
            }

            { initialValues.id && auth.user.permission == 1 && (!initialValues.status || initialValues.status == 0) &&
            <FlatButton
                label="削除"
                labelPosition="before"
                primary={true}
                labelStyle={{color: colors.white, lineHeight: '40px'}}
                style={{height: '40px', width: '100px', marginRight: '20px'}}
                backgroundColor={colors.grey600}
                hoverColor={colors.grey800}
                icon={<DeleteIcon color={colors.white}/>}
                onTouchTap={handleSubmit(onClickDelete(editUserId, yosanCosts))}
            />
            }


          { initialValues.id && initialValues.status != 0 && auth.user.permission == 2 &&
            <FlatButton
              label="解除"
              labelPosition="before"
              primary={true}
              labelStyle={{color: colors.white, lineHeight: '40px'}}
              style={{height: '40px', width: '100px', marginRight: '20px'}}
              backgroundColor={colors.grey600}
              hoverColor={colors.grey800}
              icon={<ReplyIcon color={colors.white}/>}
              onTouchTap={handleSubmit(onClickReply(editUserId))}
            />
          }


            { initialValues.id && initialValues.status != 0 && auth.user.permission == 3 && sameGroup &&
            <FlatButton
                label="解除"
                labelPosition="before"
                primary={true}
                labelStyle={{color: colors.white, lineHeight: '40px'}}
                style={{height: '40px', width: '100px', marginRight: '20px'}}
                backgroundColor={colors.grey600}
                hoverColor={colors.grey800}
                icon={<ReplyIcon color={colors.white}/>}
                onTouchTap={handleSubmit(onClickReply(editUserId))}
            />
            }

          { initialValues.id && initialValues.status == 0 && auth.user.permission == 2 &&
          <FlatButton
            label="承認"
            labelPosition="before"
            primary={true}
            labelStyle={{color: colors.white, lineHeight: '40px'}}
            style={{height: '40px', width: '100px', marginRight: '20px'}}
            backgroundColor={colors.grey600}
            hoverColor={colors.grey800}
            icon={<PersonIcon color={colors.red400}/>}
            onTouchTap={handleSubmit(onClickApproval(editUserId))}
          />
          }

            { initialValues.id && initialValues.status == 0 && auth.user.permission == 3 && sameGroup &&
            <FlatButton
                label="承認"
                labelPosition="before"
                primary={true}
                labelStyle={{color: colors.white, lineHeight: '40px'}}
                style={{height: '40px', width: '100px', marginRight: '20px'}}
                backgroundColor={colors.grey600}
                hoverColor={colors.grey800}
                icon={<PersonIcon color={colors.red400}/>}
                onTouchTap={handleSubmit(onClickApproval(editUserId))}
            />
            }

          {
            !initialValues.id && !initialValues.workHolidayDate && auth.user.permission == 2 &&
            <FlatButton
              label="続けて登録"
              labelPosition="before" 
              primary={true}
              labelStyle={{color: colors.white, lineHeight: '40px'}}
              style={{height: '40px', width: '140px', marginRight: '20px'}}
              backgroundColor={colors.cyan700}
              hoverColor={colors.cyan900}
              icon={<ForwardIcon color={colors.white}/>}
              onTouchTap={handleSubmit(onClickNext(editUserId, yosanCosts, workHoliday))}
            />
          }

            {
                !initialValues.id && !initialValues.workHolidayDate && auth.user.permission == 3 && myData &&
                <FlatButton
                    label="続けて登録"
                    labelPosition="before"
                    primary={true}
                    labelStyle={{color: colors.white, lineHeight: '40px'}}
                    style={{height: '40px', width: '140px', marginRight: '20px'}}
                    backgroundColor={colors.cyan700}
                    hoverColor={colors.cyan900}
                    icon={<ForwardIcon color={colors.white}/>}
                    onTouchTap={handleSubmit(onClickNext(editUserId, yosanCosts, workHoliday))}
                />
            }

            {
                !initialValues.id && !initialValues.workHolidayDate && auth.user.permission == 1 && (!initialValues.status || initialValues.status == 0) &&
                <FlatButton
                    label="続けて登録"
                    labelPosition="before"
                    primary={true}
                    labelStyle={{color: colors.white, lineHeight: '40px'}}
                    style={{height: '40px', width: '140px', marginRight: '20px'}}
                    backgroundColor={colors.cyan700}
                    hoverColor={colors.cyan900}
                    icon={<ForwardIcon color={colors.white}/>}
                    onTouchTap={handleSubmit(onClickNext(editUserId, yosanCosts, workHoliday))}
                />
            }


          {
            !initialValues.workHolidayDate && auth.user.permission == 2 &&
            <FlatButton
              label="登録"
              labelPosition="before"
              primary={true}
              labelStyle={{color: colors.white, lineHeight: '40px'}}
              style={{height: '40px', width: '100px'}}
              backgroundColor={colors.cyan700}
              hoverColor={colors.cyan900}
              icon={<DoneIcon color={colors.white}/>}
              type="submit"
            />
          }

            {
                !initialValues.workHolidayDate && auth.user.permission == 3 && myData &&
                <FlatButton
                    label="登録"
                    labelPosition="before"
                    primary={true}
                    labelStyle={{color: colors.white, lineHeight: '40px'}}
                    style={{height: '40px', width: '100px'}}
                    backgroundColor={colors.cyan700}
                    hoverColor={colors.cyan900}
                    icon={<DoneIcon color={colors.white}/>}
                    type="submit"
                />
            }

            {
                !initialValues.workHolidayDate && auth.user.permission == 1 && (!initialValues.status || initialValues.status == 0) &&
                <FlatButton
                    label="登録"
                    labelPosition="before"
                    primary={true}
                    labelStyle={{color: colors.white, lineHeight: '40px'}}
                    style={{height: '40px', width: '100px'}}
                    backgroundColor={colors.cyan700}
                    hoverColor={colors.cyan900}
                    icon={<DoneIcon color={colors.white}/>}
                    type="submit"
                />
            }

        </div>


        <Dialog
          title={`${initialValues.date} 残業申請状況`}
          open={this.state.applicaRefOpen}
          actions={[
            <FlatButton
              label="閉じる"
              primary={true}
              labelStyle={{ color: colors.grey500, lineHeight: '40px' }}
              style={{ height: '40px', width: '120px', marginRight: '20px' }}
              onTouchTap={() => {
                this.setState(Object.assign(this.state, {applicaRefOpen: false}))
              }}
            />
          ]}
          onRequestClose={() => {
          }}
        >
          {

            initialValues.overTimeList && initialValues.overTimeList.map(x => {
              return (
                <div>
                  <div className='row'>
                    <div className='col-3'>
                      {moment(x.startTime).format('HH:mm')}
                      &nbsp;～&nbsp;
                      {moment(x.endTime).format('HH:mm')}
                    </div>
                    <div className='col-9'>
                      {x.comment}
                    </div>
                  </div>
                </div>
              )
            })
          }
          {
            !initialValues.overTimeList && '申請なし'
          }
        </Dialog>

      </form>

    )
  }
}

RoumuForm = reduxForm({
  form: 'roumuForm',
  enableReinitialize: true,
})(RoumuForm)


export default RoumuForm


// WEBPACK FOOTER //
// ./src/containers/RoumuForm.js